// src/ProductosAlerts/ProductosAlerts.jsx
import React, { useState, useEffect } from 'react';
import { removeFromFavorites, addToFavorites, guardarLogProducto } from '../../firebase/config';
import { Link } from 'react-router-dom';
import { upperFL } from '../../utils/utils';
import "./ProductosAlerts.css";

export const ProductosAlerts = ({ producto, premium, planName, user }) => {
  const currentUser = user;
  const [userLikes, setUserLikes] = useState([]);

  // Sincroniza likes cuando cambia el usuario
  useEffect(() => {
    if (currentUser?.likes) {
      setUserLikes(currentUser.likes);
    } else {
      setUserLikes([]);
    }
  }, [currentUser]);

    // Maneja el click de "rastrear producto"
    const handleLikeClick = async (producto) => {
      if (!currentUser) return;
    
      try {
        if (userLikes.includes(producto.id)) {
          // Quitar de favoritos
          await removeFromFavorites(currentUser.uid, producto.id);
          setUserLikes(prev => prev.filter(id => id !== producto.id));
        } else {
          // Añadir a favoritos PASANDO planName
          await addToFavorites(currentUser.uid, producto.id, planName);
          setUserLikes(prev => [...prev, producto.id]);
        }
    
      } catch (error) {
        console.error('Error al manejar el like:', error);
      }
    }
  

  // Maneja click en "ver producto"
  const handleProductClick = async (producto, currentUser, premium) => {
    if (!currentUser) {
      console.warn('Usuario no logueado. No se registrará el evento.');
      return;
    }

    const logData = {
      user: currentUser.uid,
      username: currentUser.username,
      tipo_prenda: producto.hierarchicalCategories,
      size: producto.size,
      brand: producto.brand,
      estate: producto.condition,
      city_producto: producto.city,
      platform: producto.web,
      price: producto.price,
      color: producto.color,
      sex_product: producto.sex,
      sex_user: currentUser.gender,
      birthdate_user: currentUser.birthdate,
      province_user: currentUser.province,
      is_premium: premium,
      plan: planName,
      is_alert: true,
    };
    
    try {
      await guardarLogProducto(logData);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div className="producto-card producto-card-alerta">
      <img src={producto.images} alt={upperFL(producto.title)} />

      {premium && (
        <div className="precio-analisis">
          {producto.price_difference < 0 ? (
            <div className="precio-info">
              <span className="diferencia-porcentaje mejor-precio">
                ⬇ {Math.abs(producto.percentage_price_difference).toFixed(2)}%
              </span>
              <span className="diferencia-euros mejor-precio">
                -{Math.abs(producto.price_difference).toFixed(2)}€
              </span>
            </div>
          ) : (
            <div className="precio-info espacio-vacio"></div>
          )}
        </div>
      )}

      <div className="producto-info">
        <h3 className='titulo-producto'>{upperFL(producto.title)}</h3>
        <ul className="caracteristicas">
          <li className='fecha-producto'>
            <span className="valor-corte">
              {(() => {
                const now = new Date();
                const isoString = producto.scraped_date?.value || "";
                const cleanedIsoString = isoString.replace(/(\.\d{3})\d*Z$/, "$1Z");
                const scraped = new Date(cleanedIsoString);
                const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
                const scrapedDay = new Date(scraped.getFullYear(), scraped.getMonth(), scraped.getDate());
                let diffDays = Math.floor((today - scrapedDay) / (1000 * 60 * 60 * 24));
                if (diffDays < 0) diffDays = 0;
                return diffDays === 0 ? "nuevo en eRastro" : `${diffDays} ${diffDays === 1 ? "día" : "días"} en eRastro`;
              })()}
            </span>
          </li>
          <li><strong>Talla:</strong> {producto.size.toUpperCase()}</li>
          <li><strong>Estado:</strong> {upperFL(producto.condition)}</li>
          <li><strong>Marca:</strong> <span className="valor-corte">{upperFL(producto.brand)}</span></li>
          <li><strong>Ciudad:</strong> <span className="valor-corte">{upperFL(producto.city)}</span></li>
          <li><strong>Web:</strong> {upperFL(producto.web)}</li>
          <li><strong>Precio:</strong> {producto.price}€</li>
        </ul>

        <div className="botones-producto">
          <a
            href={producto.link}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => handleProductClick(producto, currentUser, premium)}
          >
            <button>Ver Producto</button>
          </a>

          {!premium && (
            <Link to="/premium">
              <button className="boton-favoritos">
                Hazte Premium para agregar favoritos
              </button>
            </Link>
          )}

          {premium && (
            <button
              className={`boton-favoritos ${userLikes.includes(producto.id) ? 'quitar' : 'agregar'}`}
              onClick={() => handleLikeClick(producto)}
            >
              {userLikes.includes(producto.id)
                ? 'Dejar de rastrear'
                : 'Rastrear producto'}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProductosAlerts;
